// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js or *_controller.ts.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

window.Stimulus = Application.start()

// Vite: import.meta.glob + shim de context reemplazan al require.context de webpacker
const contextModules = import.meta.glob("./**/*_controller.js", { eager: true })
const context = (key) => contextModules[key]
context.keys = () => Object.keys(contextModules)
Stimulus.load(definitionsFromContext(context))